import { useFormikContext } from "formik";
import React from "react";

const getFieldErrorNames = (formikErrors: any) => {
  const transformObjectToDotNotation = (obj: any, prefix = "", result: string[] = []) => {
    Object.keys(obj).forEach((key) => {
      const value = obj[key];
      if (!value) return;

      const nextKey = prefix ? `${prefix}.${key}` : key;
      if (typeof value === "object") {
        transformObjectToDotNotation(value, nextKey, result);
      } else {
        result.push(nextKey);
      }
    });

    return result;
  };

  return transformObjectToDotNotation(formikErrors);
};

const ScrollToFieldError = () => {
  const { submitCount, isValid, errors } = useFormikContext();

  const submitCountReady = submitCount | 0;

  React.useEffect(() => {
    if (isValid) return;

    const fieldErrorNames = getFieldErrorNames(errors);
    if (fieldErrorNames.length <= 0) return;

    const element = document.querySelector(`input[name='${fieldErrorNames[0]}']`);
    if (!element) return;

    // Scroll to first known error into view
    element.scrollIntoView({ behavior: "smooth", block: "center" });
  }, [submitCountReady, isValid]);

  return null;
};

export default ScrollToFieldError;
